import React from 'react';
import classNames from 'classnames';

export interface IToggleProps {
    /**
     * ID attribute.
     */
    id: string;
    /**
     * Toggle label.
     */
    label?: React.ReactNode;
    /**
     * Additional custom class.
     */
    className?: string;
    /**
     * Alternative toggle label to display when toggle is switched “on”.
     */
    onLabel?: string;
    /**
     * Properties to be passed on the input element.
     */
    input?: React.InputHTMLAttributes<HTMLInputElement>;
    /**
     * Whether the toggle is in pending status (yellow style).
     */
    isPending?: boolean;
}

const Toggle = (props: IToggleProps): JSX.Element => {
    const className: string = classNames(
        'toggle',
        {
            'toggle--with-on-label': props.onLabel,
        },
        props.className,
    );

    const inputClassName: string = classNames(
        'toggle__input',
        props.input && props.input.className,
    );

    const indicatorClassName: string = classNames('toggle__indicator', {
        'toggle__indicator--pending': props.isPending,
    });

    const offText = (
        <span className="toggle__text toggle__text--off">{props.label}</span>
    );

    const onText = (
        <span className="toggle__text toggle__text--on">{props.onLabel}</span>
    );

    return (
        <div className={className}>
            <input
                {...props.input}
                type="checkbox"
                id={props.id}
                className={inputClassName}
            />
            <label className="toggle__label" htmlFor={props.id}>
                <span className={indicatorClassName} />
                {offText}
                {props.onLabel && onText}
            </label>
        </div>
    );
};

export default Toggle;
